import React from 'react';

import SaralSkeleton from '@/components/common-components/SaralSkeleton';

const ContentCardSkeleton = () => {
  return (
    <div className="sl-content-card-skeleton">
      {/* Header with avatar and name */}
      <div className="header">
        <SaralSkeleton variant="circular" width={30} height={30} />
        <div className="user-info">
          <SaralSkeleton width={130} height={10} />
          <SaralSkeleton width={75} height={10} />
        </div>
      </div>

      {/* Main content/image */}
      <SaralSkeleton variant="rectangular" width="100%" height={396} borderRadius={4} />

      {/* Footer actions */}
      <div className="footer">
        <SaralSkeleton width={130} height={18} />
        <SaralSkeleton width={80} height={18} />
      </div>
    </div>
  );
};

export default ContentCardSkeleton;
